export function exclusiveRighttoSellListingContract2026() {
return [   // Release 2025-12-23 06:40:16
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton SellerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 277.529,
   left: 282.765,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Radiobutton SellerBrokerRelationship Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 275.874,
   left: 159.233,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 299.12,
   left: 451.56,
   width: 120.00,
   height: 11.564
}
,
{
   page: 0,
   name: "Radiobutton BrokerageFirmSize Multi Person", 
   isText: false,
   type: "checkbox",
   top: 376.2,
   left: 81.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton BrokerageFirmSize One Person", 
   isText: false,
   type: "checkbox",
   top: 436.68,
   left: 81.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 490.88,
   left: 113.88,
   width: 450.00,
   height: 11.564
}
,
{
   page: 0,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 508.28,
   left: 158.64,
   width: 408.60,
   height: 11.564
}
,
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.8,
   left: 120.0,
   width: 447.24,
   height: 11.564
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 543.32,
   left: 425.629,
   width: 141.491,
   height: 11.564
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567.493,
   left: 42.5456,
   width: 533.5654,
   height: 160.1101
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 728.0618,
   left: 102.96,
   width: 459.96,
   height: 12.2182
}
,
{
   page: 1,
   name: "Checkbox AffordableHousing Is", 
   isText: false,
   type: "checkbox",
   top: 67.8,
   left: 81.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox LeaseAgreement Is", 
   isText: false,
   type: "checkbox",
   top: 154.2,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Date Listing Begins", 
   fontSize: 9,
   type: "date",
   top: 199.68,
   left: 388.92,
   width: 180.00,
   height: 12.36
}
,
{
   page: 1,
   name: "Date Listing Ends", 
   fontSize: 9,
   type: "date",
   top: 226.474,
   left: 66.7639,
   width: 66.8721,
   height: 12.836
}
,
{
   page: 1,
   name: "TextDate Listing Ends", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.32,
   left: 134.684,
   width: 323.236,
   height: 12.36
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 368.52,
   left: 322.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 368.52,
   left: 374.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Seller Agency Only", 
   isText: false,
   type: "checkbox",
   top: 593.64,
   left: 117.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton DisclosureOfOffers Does Consent", 
   isText: false,
   type: "checkbox",
   top: 323.88,
   left: 113.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton DisclosureOfOffers Does Not Consent", 
   isText: false,
   type: "checkbox",
   top: 323.88,
   left: 168.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Percent Sale Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.96,
   left: 188.76,
   width: 64.92,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Sale Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.96,
   left: 405.28,
   width: 99.96,
   height: 12.36
}
,
{
   page: 2,
   name: "Percent Buyer Broker Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 548.4,
   left: 248.52,
   width: 54.96,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Buyer Broker Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 548.4,
   left: 452.64,
   width: 90.00,
   height: 12.36
}
,
{
   page: 2,
   name: "Percent Lease Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 614.4,
   left: 504.96,
   width: 53.454,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Lease Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 627.6,
   left: 218.56,
   width: 65.04,
   height: 10.68
}
,
{
   page: 2,
   name: "Lease Compensation Payable As Follows", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 639.36,
   left: 67.68,
   width: 499.92,
   height: 12.36
}
,
{
   page: 2,
   name: "Percent Lease Compensation To Tenant Brokerage Firm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 652.8,
   left: 505.8,
   width: 50.04,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Lease Compensation To Tenant Brokerage Firm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 666,
   left: 152.76,
   width: 64.92,
   height: 12.36
}
,
{
   page: 2,
   name: "Lease Other Compensation", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 706.9122,
   left: 58.2548,
   width: 514.5832,
   height: 35.7455
}
,
{
   page: 3,
   name: "Holdover Period Days", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 80.193,
   left: 368.16,
   width: 44.04,
   height: 10.887
}
,
{
   page: 3,
   name: "Radiobutton HoldoverSellerOwesCompensation Will", 
   isText: false,
   type: "checkbox",
   top: 107.88,
   left: 423.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton HoldoverSellerOwesCompensation Will Not", 
   isText: false,
   type: "checkbox",
   top: 107.88,
   left: 474.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmittedToMLS Will", 
   isText: false,
   type: "checkbox",
   top: 342.6,
   left: 162.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmittedToMLS Will Not", 
   isText: false,
   type: "checkbox",
   top: 342.6,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmittedToPropertyExchanges Will", 
   isText: false,
   type: "checkbox",
   top: 358.2,
   left: 162.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmittedToPropertyExchanges Will Not", 
   isText: false,
   type: "checkbox",
   top: 358.2,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Marketing Except", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 437.893,
   left: 51.7093,
   width: 523.7467,
   height: 67.818
}
,
{
   page: 3,
   name: "Radiobutton PropertyAddressOnInternet Will", 
   isText: false,
   type: "checkbox",
   top: 521.88,
   left: 198.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton PropertyAddressOnInternet Will Not", 
   isText: false,
   type: "checkbox",
   top: 521.88,
   left: 252.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton PropertyListingOnInternet Will", 
   isText: false,
   type: "checkbox",
   top: 538.92,
   left: 198.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton PropertyListingOnInternet Will Not", 
   isText: false,
   type: "checkbox",
   top: 538.92,
   left: 252.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox PropertyAccess Electronic Lock Box", 
   isText: false,
   type: "checkbox",
   top: 579,
   left: 104.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox PropertyAccess Manual Lock Box", 
   isText: false,
   type: "checkbox",
   top: 595.8,
   left: 104.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox PropertyAccess Other", 
   isText: false,
   type: "checkbox",
   top: 613.312,
   left: 103.419,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "PropertyAccess Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 609.52,
   left: 123.055,
   width: 444.960,
   height: 14.16
}
,
{
   page: 3,
   name: "PropertyAccess Other Instructions 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 625.44,
   left: 155.28,
   width: 411.96,
   height: 14.16
}
,
{
   page: 3,
   name: "PropertyAccess Other Instructions 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642.284,
   left: 68.4981,
   width: 498.7419,
   height: 12.196
}
,
{
   page: 3,
   name: "Checkbox AccessToProperty Actively Licensed Real Estate Brokers", 
   isText: false,
   type: "checkbox",
   top: 691.32,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox AccessToProperty Licensed Appraisers", 
   isText: false,
   type: "checkbox",
   top: 691.32,
   left: 316.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox AccessToProperty Unlicensed Broker Assistants", 
   isText: false,
   type: "checkbox",
   top: 708.12,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox AccessToProperty Unlicensed Inspectors", 
   isText: false,
   type: "checkbox",
   top: 708.12,
   left: 316.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Checkbox AccessToProperty Other", 
   isText: false,
   type: "checkbox",
   top: 725.16,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "AccessToProperty Other 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 720.84,
   left: 152.16,
   width: 414.96,
   height: 14.16
}
,
{
   page: 3,
   name: "AccessToProperty Other 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 738.3305,
   left: 110.619,
   width: 455.674,
   height: 21.3455
}
,
{
   page: 4,
   name: "Marketing Tasks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 66.764,
   left: 51.0548,
   width: 521.1292,
   height: 128.037
}
,
{
   page: 4,
   name: "Videos Pictures Except", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 219.274,
   left: 54.9821,
   width: 517.8559,
   height: 54.073
}
,
{
   page: 4,
   name: "Radiobutton NoExistingListingAgreement Is", 
   isText: false,
   type: "checkbox",
   top: 426.6,
   left: 352.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton NoExistingListingAgreement Is Not", 
   isText: false,
   type: "checkbox",
   top: 426.6,
   left: 393,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton ReceivedListSubmittedProperties Has", 
   isText: false,
   type: "checkbox",
   top: 440.04,
   left: 426.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton ReceivedListSubmittedProperties Has Not", 
   isText: false,
   type: "checkbox",
   top: 440.04,
   left: 472.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Amount Listing Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 650.789,
   left: 137.64,
   width: 129.96,
   height: 11.531
}
,
{
   page: 4,
   name: "Checkbox Group Loan Cash", 
   isText: false,
   type: "checkbox",
   top: 667.08,
   left: 117.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 667.08,
   left: 170.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox Group Loan FHA", 
   isText: false,
   type: "checkbox",
   top: 667.08,
   left: 254.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox Group Loan VA", 
   isText: false,
   type: "checkbox",
   top: 667.08,
   left: 299.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 667.08,
   left: 340.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.964,
   left: 392.88,
   width: 174.36,
   height: 12.076
}
,
{
   page: 4,
   name: "Loan Discount Points", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 680.389,
   left: 180.48,
   width: 386.76,
   height: 12.731
}
,
{
   page: 4,
   name: "Amount FHA Closing Costs", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 696.8836,
   left: 446.88,
   width: 89.64,
   height: 12.0764
}
,
{
   page: 4,
   name: "FHA Not Allowed To Pay", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 710.04,
   left: 278.16,
   width: 288.96,
   height: 14.04
}
,
{
   page: 4,
   name: "Amount Earnest Money Minimum", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 727.0691,
   left: 340.8,
   width: 84.12,
   height: 12.7309
}
,
{
   page: 4,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 741.9491,
   left: 158.28,
   width: 409.20,
   height: 12.7309
}
,
{
   page: 5,
   name: "Radiobutton SellerProceeds Cashiers Check", 
   isText: false,
   type: "checkbox",
   top: 58.92,
   left: 59.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton SellerProceeds Wire Transfer", 
   isText: false,
   type: "checkbox",
   top: 74.76,
   left: 59.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton SellerProceeds Closing Companys Trust Account", 
   isText: false,
   type: "checkbox",
   top: 90.6,
   left: 59.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 132.12,
   left: 259.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 316.08,
   left: 341.16,
   width: 110.04,
   height: 10.68
}
,
{
   page: 5,
   name: "Checkbox Group Inclusions None", 
   isText: false,
   type: "checkbox",
   top: 340.92,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 340.92,
   left: 111.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 340.92,
   left: 185.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 340.92,
   left: 279.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 340.92,
   left: 376.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 463.42,
   left: 55.6366,
   width: 523.0934,
   height: 101.855
}
,
{
   page: 5,
   name: "Encumbered Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 600.22,
   left: 56.2911,
   width: 522.4389,
   height: 50.146
}
,
{
   page: 5,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 700.3667,
   left: 68.7275,
   width: 509.3475,
   height: 60.6183
}
,
{
   page: 6,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 90.328,
   left: 53.673,
   width: 519.165,
   height: 92.037
}
,
{
   page: 6,
   name: "Trade Fixtures Included", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 182.28,
   left: 326.16,
   width: 240.96,
   height: 12.60
}
,
{
   page: 6,
   name: "Trade Fixtures Included Encumbrance Exception", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 208.8,
   left: 305.28,
   width: 261.84,
   height: 12.48
}
,
{
   page: 6,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 250.32,
   left: 58.68,
   width: 509.52,
   height: 12.60
}
,
{
   page: 6,
   name: "Storage Facilities", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 278.68,
   left: 58.68,
   width: 509.88,
   height: 12.60
}
,
{
   page: 6,
   name: "Checkbox Group WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 311.16,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "WaterRights Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 322.038,
   left: 62.8366,
   width: 508.0384,
   height: 92.036
}
,
{
   page: 6,
   name: "Deeded Water Rights Deed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.84,
   left: 348.72,
   width: 155.64,
   height: 12.60
}
,
{
   page: 6,
   name: "Checkbox Group WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 433.32,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 430.68,
   left: 372,
   width: 195.12,
   height: 12.60
}
,
{
   page: 6,
   name: "Checkbox Group WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 449.16,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "WaterRights Water Stock", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 460.802,
   left: 62.8366,
   width: 508.0384,
   height: 61.273
}
,
{
   page: 6,
   name: "Checkbox Group WaterRights Other Rights Relating to Water", 
   isText: false,
   type: "checkbox",
   top: 523.08,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "WaterRights Other Rights Relating to Water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 549.166,
   left: 60.873,
   width: 510.656,
   height: 59.964
}
,
{
   page: 6,
   name: "Growing Crops", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 620.512,
   left: 54.3275,
   width: 516.5475,
   height: 70.436
}
,
{
   page: 7,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 48.96,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 48.96,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 48.96,
   left: 413.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 63.84,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 63.84,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Deed Other", 
   isText: false,
   type: "checkbox",
   top: 78.709,
   left: 59.5639,
   width: 10.0800,
   height: 9.426
}
,
{
   page: 7,
   name: "DeedType Deed Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 76.96,
   left: 77.76,
   width: 465.00,
   height: 12.60
}
,
{
   page: 7,
   name: "Monetary Encumbrances", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 173.455,
   left: 53.0184,
   width: 513.2746,
   height: 12.837
}
,
{
   page: 7,
   name: "Tenancies", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 224.546,
   left: 52.3639,
   width: 520.4741,
   height: 44.255
}
,
{
   page: 7,
   name: "RadioButton LocatedInOwersAssociation Is", 
   isText: false,
   type: "checkbox",
   top: 334.2,
   left: 346.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "RadioButton LocatedInOwersAssociation Is Not", 
   isText: false,
   type: "checkbox",
   top: 334.2,
   left: 383.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Amount Association Assessment", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 370.32,
   left: 169.92,
   width: 114.96,
   height: 12.60
}
,
{
   page: 7,
   name: "Frequency Association Assessment", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 370.32,
   left: 302.64,
   width: 249.96,
   height: 12.60
}
,
{
   page: 7,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 399.84,
   left: 58.8,
   width: 510.0,
   height: 12.60
}
,
{
   page: 7,
   name: "Possession Details", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 498,
   left: 49.68,
   width: 519.96,
   height: 12.6
}
,
{
   page: 7,
   name: "Radiobutton SellerProvidesSPD Agrees", 
   isText: false,
   type: "checkbox",
   top: 643.32,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton SellerProvidesSPD Does Not Agree", 
   isText: false,
   type: "checkbox",
   top: 643.32,
   left: 350.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton ForfeitureOfPayments Paid To Seller", 
   isText: false,
   type: "checkbox",
   top: 383.88,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton ForfeitureOfPayments Split Seller And Brokerage Firm", 
   isText: false,
   type: "checkbox",
   top: 399.24,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton ForfeitureOfPayments Other", 
   isText: false,
   type: "checkbox",
   top: 427.56,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "ForfeitureOfPayments Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 423.12,
   left: 128.16,
   width: 438.96,
   height: 14.40
}
,
{
   page: 9,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 319.419,
   left: 37.9638,
   width: 543.3832,
   height: 441.566
}
,
{
   page: 10,
   name: "Additional Provisions 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 37.964,
   left: 41.2365,
   width: 528.9835,
   height: 27.236
}
,
{
   page: 10,
   name: "Attachments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 76.582,
   left: 41.2365,
   width: 528.9835,
   height: 86.800
}
,
{
   page: 10,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 264.96,
   left: 285.84,
   width: 276.72,
   height: 10.80
}
,
{
   page: 10,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.763,
   left: 125.953,
   width: 450.000,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.803,
   left: 125.953,
   width: 444.960,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 540.563,
   left: 125.953,
   width: 170.040,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 540.563,
   left: 438.433,
   width: 135.000,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 555.573,
   left: 126.231,
   width: 450.000,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 584.304,
   left: 126.82,
   width: 450.00,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.748,
   left: 127.808,
   width: 444.960,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 636.628,
   left: 128.463,
   width: 170.040,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 636.628,
   left: 440.943,
   width: 135.000,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 651.567,
   left: 128.276,
   width: 450.000,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 670.908,
   left: 127.783,
   width: 450.000,
   height: 11.542
}
,
{
   page: 10,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.6282,
   left: 126.165,
   width: 450.000,
   height: 11.5418
}
,
{
   page: 11,
   name: "Seller Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 43.346,
   left: 119.28,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller Broker Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 59.48,
   left: 119.28,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 77.964,
   left: 124.055,
   width: 343.092,
   height: 11.411
}
,
{
   page: 11,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 97.88,
   left: 72.76,
   width: 174.96,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 126.68,
   left: 184.68,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 140.12,
   left: 184.68,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 153.56,
   left: 184.68,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 167.0,
   left: 184.68,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 180.68,
   left: 184.68,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Seller CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 215.72,
   left: 133.28,
   width: 349.92,
   height: 11.411
}
,
{
   page: 11,
   name: "Signature Seller CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 234.71,
   left: 140.382,
   width: 340.474,
   height: 11.411
}
,
{
   page: 11,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 254.12,
   left: 70.76,
   width: 174.96,
   height: 11.411
}
] }
